"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.48,0H.52A.52.52,0,0,0,0,.52V6.26H24V.52A.52.52,0,0,0,23.48,0Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.76,19.59h0V19a.45.45,0,0,0,0-.16.45.45,0,0,1,0,.16Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.69,7.3h0v4h0v2.8A1.42,1.42,0,0,1,18,15.52V17.6h1.36a1.4,1.4,0,0,1,1.35,1h1.44A1.41,1.41,0,0,1,23.54,20v1a1.42,1.42,0,0,1-1.41,1.42H16.69V24h6.79a.65.65,0,0,0,.2,0,.53.53,0,0,0,.32-.49V7.3H16.69Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.62,22.41A1.42,1.42,0,0,1,2.21,21V20a1.41,1.41,0,0,1,1.41-1.41H5V17.38A1.42,1.42,0,0,1,6.41,16h.9V7.3H0V23.47A.52.52,0,0,0,.52,24H7.31V22.41H3.62Z"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "8.35 22.41 8.35 24 8.35 24 12.62 24 12.62 24 15.65 24 15.65 24 15.65 22.41 11.48 22.41 8.35 22.41"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.07,15.52a1.41,1.41,0,0,1,1.41-1.41h4.17V7.3H8.35V16h1.72Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.13,19.59H19.76V19a.45.45,0,0,0,0-.16.42.42,0,0,0-.39-.25H17V15.52a.42.42,0,0,0-.29-.39l-.13,0H11.48a.41.41,0,0,0-.41.41V17H6.41a.41.41,0,0,0-.42.41v2.21H3.62a.45.45,0,0,0-.16,0,.41.41,0,0,0-.25.38v1a.42.42,0,0,0,.25.39.45.45,0,0,0,.16,0H22.13a.41.41,0,0,0,.41-.42V20A.41.41,0,0,0,22.13,19.59Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.62,21.41h0a.45.45,0,0,1-.16,0A.45.45,0,0,0,3.62,21.41Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.62,19.59a.45.45,0,0,0-.16,0,.45.45,0,0,1,.16,0Z",
    style: {
      fill: '#fff'
    }
  })));
};

exports["default"] = _default;